export const HTTP_NOT_UNAUTHORIZED_STATUS = 401;
export const HTTP_FORBIDDEN_STATUS = 403;
export const HTTP_SERVICE_UNAVAILABLE_STATUS = 503;
export const HTTP_BAD_REQUEST_STATUS = 400;
export const HTTP_INTERNAL_SERVER_ERROR_STATUS = 500;
export const HTTP_NOT_FOUND_STATUS = 404;
